import * as React from 'react';
import * as styles from './Analytics.css';
import { inject, observer} from 'mobx-react';
import { AnalyticsStore } from './stores';
import {MessagesTab} from './tabs/MessagesTab';
import { MobileDevicesTab } from './tabs/MobileDevicesTab';
import { IAPivot } from '../../../src/components/pivot/Pivot';
import { LocalizationService } from '../../../src/services/LocalizationService'
export interface IProps {
  analyticsStore?: AnalyticsStore;
}

export interface IState {
  display: string;
  showMobileDevicesTab: boolean;
}

@inject('analyticsStore')
@observer
export class Analytics extends React.Component<IProps, IState> {
  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      display: "Messages",
      showMobileDevicesTab: true
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  private renderTab(): React.ReactElement{
    switch (this.state.display) {
      case "Messages":
        return <MessagesTab/> 
      case "MobileDevices":
        return <MobileDevicesTab/>
      default:
        break;
    } 
  }
  
  public render(): JSX.Element {
  if (this.state.showMobileDevicesTab) {
   var tabItems = [{
    key: "Messages",
    text: this.localizationService.strings.Messages_PivotMessages
     },
    {
    key: "MobileDevices",
    text: this.localizationService.strings.Analytics_PivotMobileDevices
    }];
  } 
  else {
    var tabItems = [{
      key: "Messages",
      text: this.localizationService.strings.Messages_PivotMessages
    }];
  }
    return (
      <div className={styles.IA_analytics}>
        { <IAPivot
          highlightColor="#23879b"
          items={tabItems}
          selectedKey={this.state.display}
          select={(display: string) => this.setState({ display })}
        /> }
        {this.renderTab()}
      </div>
    );
  }
}